document.addEventListener("DOMContentLoaded", function() {
  // Function to handle view cart button in quick-buy-drawer
  function handleViewCartButton() {
    // Handle all quick-buy-drawers on the page (for collection pages with multiple drawers)
    const quickBuyDrawers = document.querySelectorAll('quick-buy-drawer');
    
    if (quickBuyDrawers.length === 0) {
      console.log('No quick buy drawers found');
      return;
    }
    
    quickBuyDrawers.forEach(function(quickBuyDrawer) {
      // Look for view cart links specifically inside this quick-buy-drawer
      const viewCartLink = quickBuyDrawer.querySelector('.buy-buttons--compact a.button--secondary[href="/cart"]');
      
      if (viewCartLink && !viewCartLink.hasAttribute('data-customized')) {
        console.log('Found view cart link in quick-buy-drawer, replacing with close button');
        
        // Create new button
        const customButton = document.createElement('button');
        customButton.type = 'button';
        customButton.className = viewCartLink.className;
        customButton.textContent = viewCartLink.textContent;
        customButton.style.cursor = 'pointer';
        customButton.setAttribute('data-customized', 'true');
        
        // Add click handler to close the drawer
        customButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('View cart button clicked, closing quick-buy-drawer');
          
          // Simply close the quick buy drawer without opening cart
          if (quickBuyDrawer && typeof quickBuyDrawer.hide === 'function') {
            quickBuyDrawer.hide();
          }
          
          // Prevent any cart drawer from opening
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.hasAttribute('open')) {
            cartDrawer.removeAttribute('open');
          }
          
          // Additional prevention: remove any cart drawer open state
          setTimeout(function() {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && cartDrawer.hasAttribute('open')) {
              cartDrawer.removeAttribute('open');
            }
            // Also try to close any cart drawer that might have opened
            if (cartDrawer && typeof cartDrawer.hide === 'function') {
              cartDrawer.hide();
            }
          }, 10);
          
          return false;
        });
        
        // Replace the link with the button
        viewCartLink.parentNode.replaceChild(customButton, viewCartLink);
      } else if (!viewCartLink) {
        console.log('View cart link not found in this quick-buy-drawer');
      } else {
        console.log('View cart link already customized in this drawer');
      }
    });
  }

  // Initial call
  handleViewCartButton();

  // Listen for variant added event
  document.addEventListener('variant:add', function() {
    // Wait for the drawer content to update
    setTimeout(handleViewCartButton, 100);
  });

  // Listen for drawer content changes
  const drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        handleViewCartButton();
      }
    });
  });

  // Observe all quick buy drawers
  const quickBuyDrawers = document.querySelectorAll('quick-buy-drawer');
  quickBuyDrawers.forEach(function(quickBuyDrawer) {
    drawerObserver.observe(quickBuyDrawer, { childList: true, subtree: true });
  });

  // Also observe the document for when quick-buy-drawer elements are added
  const documentObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if the added node is a quick-buy-drawer
            if (node.tagName === 'QUICK-BUY-DRAWER') {
              console.log('Quick buy drawer added to DOM');
              // Start observing this new drawer
              drawerObserver.observe(node, { childList: true, subtree: true });
              setTimeout(handleViewCartButton, 100);
            }
            // Check if the added node contains quick-buy-drawer elements
            const quickBuyDrawersInNode = node.querySelectorAll ? node.querySelectorAll('quick-buy-drawer') : [];
            quickBuyDrawersInNode.forEach(function(drawer) {
              console.log('Quick buy drawer found in added node');
              drawerObserver.observe(drawer, { childList: true, subtree: true });
            });
            if (quickBuyDrawersInNode.length > 0) {
              setTimeout(handleViewCartButton, 100);
            }
          }
        });
      }
    });
  });

  documentObserver.observe(document.body, { childList: true, subtree: true });

  // Additional prevention: intercept any cart navigation
  document.addEventListener('click', function(e) {
    const target = e.target;
    // Check if this is a view cart button that we've customized
    if (target.hasAttribute && target.hasAttribute('data-customized') && 
        target.textContent.toLowerCase().includes('view cart')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Find the closest quick-buy-drawer and close it
      const quickBuyDrawer = target.closest('quick-buy-drawer');
      if (quickBuyDrawer && typeof quickBuyDrawer.hide === 'function') {
        quickBuyDrawer.hide();
      }
      
      return false;
    }
  }, true); // Use capture phase to intercept early

  // Global function to close quick buy drawer
  window.closeQuickBuyDrawer = function() {
    // Try to close any open quick-buy-drawer
    const openQuickBuyDrawers = document.querySelectorAll('quick-buy-drawer[open]');
    let closed = false;
    
    openQuickBuyDrawers.forEach(function(quickBuyDrawer) {
      if (typeof quickBuyDrawer.hide === 'function') {
        quickBuyDrawer.hide();
        closed = true;
      }
    });
    
    if (!closed) {
      // Fallback: try to close any open drawer
      const openDrawer = document.querySelector('.drawer[open], .drawer.is-open, .drawer.active');
      if (openDrawer && typeof openDrawer.hide === 'function') {
        openDrawer.hide();
      }
    }
  };
});

// Lazy loading for videos
var lazyVideos = [].slice.call(document.querySelectorAll("video.lazyload_videos"));

if ("IntersectionObserver" in window) {
  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(video) {
      if (video.isIntersecting) {
        for (var source in video.target.children) {
          var videoSource = video.target.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src; // Load the actual video source
          }
        }
        video.target.load(); // Load the video
        video.target.classList.remove("lazyload_videos");
        lazyVideoObserver.unobserve(video.target);
      }
    });
  });

  lazyVideos.forEach(function(lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
}

var lazyIframes = [].slice.call(document.querySelectorAll("iframe.lazy"));

if ("IntersectionObserver" in window) {
  var iframeObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var iframe = entry.target;
        iframe.src = iframe.dataset.src; // Load iframe content
        iframe.classList.remove("lazy");
        iframeObserver.unobserve(iframe);
      }
    });
  });

  lazyIframes.forEach(function (iframe) {
    iframeObserver.observe(iframe);
  });
}

// Custom video auto-play observer
const customVideoObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const video = entry.target.querySelector(".custom-video");
    if (video && video.tagName.toLowerCase() === "video") {
      if (entry.isIntersecting) {
        video.play().catch(function(error) {
          console.log('Video autoplay failed:', error);
        });
      } 
    }
  });
}, {
  threshold: 0.5
});

// Observe all video blocks
document.querySelectorAll('[data-block-type="video"]').forEach((block) => {
  customVideoObserver.observe(block);
});

// Additional video loading for any video elements that might not be caught
document.addEventListener('DOMContentLoaded', function() {
  // Load any videos that have data-src attributes
  const videosWithDataSrc = document.querySelectorAll('video source[data-src]');
  videosWithDataSrc.forEach(function(source) {
    if (source.dataset.src && !source.src) {
      source.src = source.dataset.src;
      source.parentElement.load();
    }
  });

  // Auto-play videos that are visible
  const allVideos = document.querySelectorAll('video');
  const videoVisibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && video.paused && !video.muted) {
        video.play().catch(function(error) {
          console.log('Video autoplay failed:', error);
        });
      }
    });
  }, { threshold: 0.3 });

  allVideos.forEach(function(video) {
    videoVisibilityObserver.observe(video);
  });
});

// how it works info scroll
document.getElementById("howItWorksBtn").addEventListener("click", function() {
  document.getElementById("howItWorksInfo").scrollIntoView({ behavior: "smooth" });
});
// how it works info scroll

// bank offers scroll start
// Optional: swipe with mouse/touch for desktop/mobile
const scrollEl = document.getElementById('bankOffersScroll');
if (scrollEl) {
  let isDown = false;
  let startX, scrollLeft;
  scrollEl.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollEl.classList.add('active');
    startX = e.pageX - scrollEl.offsetLeft;
    scrollLeft = scrollEl.scrollLeft;
  });
  scrollEl.addEventListener('mouseleave', () => {
    isDown = false;
    scrollEl.classList.remove('active');
  });
  scrollEl.addEventListener('mouseup', () => {
    isDown = false;
    scrollEl.classList.remove('active');
  });
  scrollEl.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollEl.offsetLeft;
    const walk = (x - startX) * 1.2;
    scrollEl.scrollLeft = scrollLeft - walk;
  });
}
// bank offers scroll end
// product slider start
$(document).ready(function() {
  // Inject responsive CSS for the lightbox container height
  if (!document.getElementById('lightbox-responsive-style')) {
    const style = document.createElement('style');
    style.id = 'lightbox-responsive-style';
    style.textContent = `
      @media (min-width: 1000px) {
        #lightbox-container {
          height: 600px !important;
        }
      }
      @media (max-width: 999px) {
        #lightbox-container {
          height: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  $('.product_slider').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    video: true,
    dots: false,
    items: 2
  });
  
  $(window).on('load', function(){
    $('.product_slider').trigger('refresh.owl.carousel');
  });

  // Initialize lightbox functionality
  function setupLightbox() {
    // Remove any existing click handlers to prevent duplicates
    $('.product-gallery__media').off('click');
    
    // Add click handler to all media items
    $('.product-gallery__media').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const $clicked = $(this);
      const $galleryItems = $('.product-gallery .product-gallery__media'); // include all
      const index = $galleryItems.index($clicked);
      const mediaType = $clicked.data('media-type');
      const imgSrc = $clicked.find('img').attr('src');
      const videoSrc = $clicked.find('video source').attr('data-src') || $clicked.find('video source').attr('src');
      if (mediaType === 'image') {
        openLightbox(imgSrc, 'image', index, $galleryItems);
      } else if (mediaType === 'video') {
        openLightbox(videoSrc, 'video', index, $galleryItems);
      }
    });
  }

  // Call setupLightbox immediately
  setupLightbox();

  // Also call setupLightbox when carousel is initialized
  $('.product_slider').on('initialized.owl.carousel', function() {
    setupLightbox();
  });

  function openLightbox(src, type = 'image', startIndex = null, customGalleryItems = null) {
    // Remove any existing lightbox
    $('#lightbox-container').remove();
    const $gallery = $('.product-gallery');
    const $galleryItems = customGalleryItems || $gallery.find('.product-gallery__media');
    let currentIndex = (startIndex !== null) ? startIndex : 0;
    const lightboxHTML = `
      <div id="lightbox-container" style="position: relative; width: fit-content; max-width: 100%; background: #fff; box-shadow: 0 8px 32px rgba(0,0,0,0.25); display: flex; align-items: center; justify-content: center; border-radius: 12px; cursor: zoom-out; margin: 0 auto;">
        <button class="lightbox-close" style="position: absolute; top: 16px; right: 16px; background: none; border: none; color: #222; font-size: 28px; cursor: pointer; z-index: 3; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; opacity: 0.7; transition: opacity 0.2s;">×</button>
        <button class="lightbox-prev" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background: #fff9; border: none; color: #000; font-size: 35px; font-weight: 100; cursor: pointer; padding: 8px; z-index: 3; width: 1.25rem; height: 3.75rem; display: flex; align-items: center; justify-content: center; opacity: 0.7; transition: opacity 0.2s; box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 8px;">‹</button>
        <button class="lightbox-next" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); background: #fff9; border: none; color: #000; font-size: 35px; font-weight: 100; cursor: pointer; padding: 8px; z-index: 3; width: 1.25rem; height: 3.75rem; display: flex; align-items: center; justify-content: center; opacity: 0.7; transition: opacity 0.2s; box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 8px;">›</button>
        <div class="lightbox-media-content" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;"></div>
      </div>
    `;
    // Hide only the .product-gallery__ar-wrapper and append the lightbox to the gallery
    $gallery.find('.product-gallery__ar-wrapper').css('display', 'none');
    $gallery.append(lightboxHTML);
    const $lightbox = $('#lightbox-container');
    $lightbox.css('display', 'block');
    function renderContent(index) {
      let $item = $galleryItems.eq(index);
      let type = $item.data('media-type');
      let src = type === 'video' ? $item.find('video source').attr('data-src') : $item.find('img').attr('src');
      const $mediaContent = $lightbox.find('.lightbox-media-content');

      if (type === 'image') {
        // Preload image
        const img = new window.Image();
        img.onload = function() {
          $mediaContent.html('');
          img.style.cssText = "max-width: 100%; max-height: 100%; height: 100%; display: flex; width: 100%; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.10); object-fit:contain;";
          $mediaContent.append(img);
        };
        img.src = src;
      } else if (type === 'video') {
        // Preload video
        const video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.muted = true;
        video.loop = true;
        video.style.cssText = "max-width: 100%; max-height: 100%; height: 100%; display: flex; width: 100%; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.10);";
        const source = document.createElement('source');
        source.src = src;
        source.type = "video/mp4";
        video.appendChild(source);

        video.onloadeddata = function() {
          $mediaContent.html('');
          $mediaContent.append(video);
        };
        // Start loading
        video.load();
      }
    }
    renderContent(currentIndex);
    $lightbox.show();
    // Close on click of close icon or outside media
    $lightbox.on('click', function(e) {
      if ($(e.target).is('.lightbox-close')) {
        $lightbox.hide();
        $gallery.find('.product-gallery__ar-wrapper').css('display', 'block');
        $lightbox.remove();
      }
    });
    // Close on click of image or video
    $lightbox.find('.lightbox-media-content').on('click', 'img, video', function(e) {
      e.stopPropagation();
      $lightbox.hide();
      $gallery.find('.product-gallery__ar-wrapper').css('display', 'block');
      $lightbox.remove();
    });
    // Prevent closing when clicking arrows
    $lightbox.find('.lightbox-prev, .lightbox-next').on('click', function(e) { e.stopPropagation(); });
    // Prev/Next navigation
    $lightbox.find('.lightbox-prev').on('click', function() {
      currentIndex = (currentIndex - 1 + $galleryItems.length) % $galleryItems.length;
      renderContent(currentIndex);
    });
    $lightbox.find('.lightbox-next').on('click', function() {
      currentIndex = (currentIndex + 1) % $galleryItems.length;
      renderContent(currentIndex);
    });
  }

  function closeLightbox() {
    const $lightbox = $('#lightbox-container');
    $('#lightbox-overlay').fadeOut(200);
    $lightbox.fadeOut(200, function() {
      $gallery.find('.product-gallery__ar-wrapper').css('display', 'block');
      $(this).remove();
    });
  }

  function showPrevMedia() {
    const $carousel = $('.product_slider');
    $carousel.trigger('prev.owl.carousel');
    const $activeItem = $carousel.find('.owl-item.active .product-gallery__media');
    const mediaType = $activeItem.data('media-type');
    const imgSrc = $activeItem.find('img').attr('src');
    const videoSrc = $activeItem.find('video source').attr('data-src');
    openLightbox(mediaType === 'video' ? videoSrc : imgSrc, mediaType);
  }

  function showNextMedia() {
    const $carousel = $('.product_slider');
    $carousel.trigger('next.owl.carousel');
    const $activeItem = $carousel.find('.owl-item.active .product-gallery__media');
    const mediaType = $activeItem.data('media-type');
    const imgSrc = $activeItem.find('img').attr('src');
    const videoSrc = $activeItem.find('video source').attr('data-src');
    openLightbox(mediaType === 'video' ? videoSrc : imgSrc, mediaType);
  }

  // Add keyboard navigation
  $(document).on('keydown', function(e) {
    if ($('#lightbox-container').is(':visible')) {
      if (e.keyCode === 27) { // ESC key
        closeLightbox();
      } else if (e.keyCode === 37) { // Left arrow
        showPrevMedia();
      } else if (e.keyCode === 39) { // Right arrow
        showNextMedia();
      }
    }
  });

  // Update lightbox width on window resize
  $(window).on('resize', function() {
    if ($('#lightbox-container').is(':visible')) {
      const $productGallery = $('.product-gallery');
      const galleryWidth = $productGallery.width();
      const $lightbox = $('#lightbox-container');
      // $lightbox.css('width', '100%');
    }
  });
});

// sticky add to cart 

document.addEventListener('DOMContentLoaded', function() {
  // Control visibility of the existing product-quick-add (sticky add to cart)
  const mainAddToCartBtn = document.querySelector('.custom-product .product-info__buy-buttons button[type="submit"].button');
  const quickAddToCart = document.querySelector('.custom-product .product-quick-add');

  if (mainAddToCartBtn && quickAddToCart) {
    // By default, make sure the quick add is visible
    quickAddToCart.classList.remove('hidden-quick-add');
    quickAddToCart.classList.add('visible-quick-add');
    
    // Use Intersection Observer to detect when main button is visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Main button is visible (or within 50px), hide quick add
          quickAddToCart.classList.add('hidden-quick-add');
          quickAddToCart.classList.remove('visible-quick-add');
        } else {
          // Main button is not visible, show quick add
          quickAddToCart.classList.remove('hidden-quick-add');
          quickAddToCart.classList.add('visible-quick-add');
        }
      });
    }, { 
      threshold: 0, // Use the default threshold of 0
      rootMargin: '-50px 0px 0px 0px' // Trigger 50px before the element enters the viewport
    });
    
    // Start observing the main Add to Cart button
    observer.observe(mainAddToCartBtn);
  }
});

// cart drawer script start
document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.querySelector('#shopify-section-cart-drawer');

  if (!drawer) return;

  drawer.addEventListener('click', function (event) {
    const button = event.target.closest('.quantity-selector__button');
    if (!button) return;

    const selector = button.closest('.quantity-selector');
    const input = selector.querySelector('.quantity-selector__input');
    const step = parseInt(input.getAttribute('step')) || 1;
    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    const lineKey = input.dataset.lineKey;
    let currentQty = parseInt(input.value);

    if (button.classList.contains('decrease-btn')) {
      currentQty = currentQty - step;
      if (currentQty <= 0) {
        // Remove item from cart
        updateCartItemQuantity(lineKey, 0);
        return;
      }
      currentQty = Math.max(min, currentQty);
    } else if (button.classList.contains('increase-btn')) {
      currentQty = Math.min(max, currentQty + step);
    }

    if (currentQty !== parseInt(input.value)) {
      input.value = currentQty;
      updateCartItemQuantity(lineKey, currentQty);
    }
  });

  // Handle input change separately
  document.addEventListener('change', function (event) {
    const input = event.target.closest('.quantity-selector__input');
    if (!input) return;

    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    let qty = parseInt(input.value);
    const lineKey = input.dataset.lineKey;

    if (isNaN(qty) || qty < min) qty = min;
    if (qty > max) qty = max;

    input.value = qty;
    updateCartItemQuantity(lineKey, qty);
  });

  function updateCartItemQuantity(lineKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(res => res.json())
      .then(cart => {
        fetch('/?section_id=cart-drawer')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('#shopify-section-cart-drawer');
            const oldDrawer = document.querySelector('#shopify-section-cart-drawer');
            if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
            }
          });
      })
      .catch(err => console.error('Cart update error:', err));
  }
});
// cart drawer script end

// cart discount bar start
function updateCartDiscountBar() {
  // Replace 'cart-drawer' with your section's actual handle if different
  fetch(window.location.pathname + '?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      // Create a temporary DOM to parse the response
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Find the new discount bar in the fetched section
      const newBar = tempDiv.querySelector('#cart-discount-bar');
      const currentBar = document.querySelector('#cart-discount-bar');

      if (newBar && currentBar) {
        currentBar.replaceWith(newBar);
      } else if (newBar && !currentBar) {
        // If the bar didn't exist before, insert it (e.g., before the total)
        const totalRow = document.querySelector('.footer_price');
        if (totalRow) {
          totalRow.parentNode.insertBefore(newBar, totalRow);
        }
      } else if (!newBar && currentBar) {
        // If the bar was removed (no discount), remove it from DOM
        currentBar.remove();
      }
    });
}

// Listen for cart updates (you may need to adjust this event for your theme)
document.addEventListener('cart:updated', updateCartDiscountBar);

// Optionally, call once on page load
document.addEventListener('DOMContentLoaded', updateCartDiscountBar);
// cart discount bar end

$(document).ready(function() {
  // bank offers slider start
  $('.bank-offers-slider').owlCarousel({
    loop: false,
    margin: 16,
    nav: true,
    dots: false,
    items: 1
  });
  // bank offers slider end

  // testimonials slider start
  $('.testimonials-slider').owlCarousel({
    loop: true,
    margin: 16, // or var(--spacing-4) if you want to match your design
    nav: true,
    dots: false,
    items: 1.2
  });
  $(window).on('load', function(){
    $('.bank-offers-slider').trigger('refresh.owl.carousel');
    $('.testimonials-slider').trigger('refresh.owl.carousel');
  });
  // testimonials slider end
});

// reviews section 
if(document.getElementById("scroll-to-reviews")){
  document.getElementById("scroll-to-reviews").addEventListener("click", function() {
    document.getElementById("shopify-section-template--15543107977349__173413548834440c51").scrollIntoView({ behavior: "smooth" });
  });
}